import { render } from "./LocalInput.vue?vue&type=template&id=64422d76&ts=true"
import script from "./LocalInput.vue?vue&type=script&lang=ts"
export * from "./LocalInput.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__